import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { AccountingEnvironment } from '@mews-commander/data-access';
import { getAccountingEnvironmentByCode } from '@mews-commander/legacy-entities/src/ducks/accountingEnvironments';
import { useCommanderSelector } from '@mews-commander/utils';

export const useCurrentAccountingEnvironment = (): AccountingEnvironment => {
    const { accountingEnvironmentCode } = useCurrentEnterprise();
    return useCommanderSelector((state) => getAccountingEnvironmentByCode(state, { code: accountingEnvironmentCode }));
};
